import { __ } from '@wordpress/i18n';
import { PanelBody, TextControl, ToggleControl, SelectControl } from '@wordpress/components';
import { TinyEditor } from '../Panel/TinyEditor/TinyEditor';
import { btnAlignOpt } from '../../../../utils/options';
import { produce } from 'immer';
import { useEffect, useState } from 'react'


const General = ({ attributes, updateObj, updateObject, setAttributes }) => {
    const { content, button } = attributes;
    const { btnText, title, desc } = content;
    const [description, setDescription] = useState(desc);

    useEffect(() => {
        const newDesc = produce(content, draft => {
            draft.desc = description;
        })
        setAttributes({ content: newDesc });
    }, [description])


    return <>
        <PanelBody className='bPlPanelBody' title={__('Settings', 'smart-modal')} initialOpen={true}>
            <TextControl label={__('Button Title', 'smart-modal')} value={btnText} onChange={(val) => updateObj('content', val, 'btnText')} />

            <TextControl label={__('Title', 'smart-modal')} value={title} onChange={(val) => updateObj('content', val, 'title')} />

            <TinyEditor value={desc} onChange={(val) => { setDescription(val); }} />

        </PanelBody>


        <PanelBody className='bPlPanelBody bpsmbPanelBody' title={__('Button', 'smart-modal')} initialOpen={false}>
            <ToggleControl className='mb20' label={__('Full width', 'smart-modal')} checked={button?.isFullWidth} onChange={val => updateObject("button", "isFullWidth", val)} />

            {
                !button?.isFullWidth && <SelectControl label={__('Position', 'smart-modal')} labelPosition='side' value={button?.align} options={btnAlignOpt} onChange={(val) => updateObject("button", "align", val)} />
            }

        </PanelBody>
    </>
}
export default General;